import { isServer, isUndefined } from '../utils';

type Options = {
  limit?: number;
  gap: number;
  buttonWidth: number;
};

/**
 * 用於計算更多/收起按鈕插入的位置，需求是最多顯示兩行，並在最後位置插入按鈕
 * @param elemId string 元素id名稱
 * @param options {limit: number, gap: number, buttonWidth: number} 計算gap與第limit行按鈕預留寬度
 * @returns number 看更多/收起按鈕插入位置
 */

const ROW_LIMIT = 3;

export const calculateCollapsedButtonOrder = (target: HTMLDivElement | null, options: Options): number => {
  if (isServer || isUndefined(target)) return -1;

  const { limit = ROW_LIMIT, gap, buttonWidth } = options;

  const boundRect = target?.getBoundingClientRect();
  const len = (target?.children as HTMLCollection)?.length || 0;
  const maxWidth = boundRect?.width || 0;

  let loc = 0;
  let currentRow = 0;

  if (len > 0 && maxWidth > 0) {
    const availableSize = new Array(limit - 1)?.fill(maxWidth)?.concat([maxWidth - buttonWidth - gap]); // 定義每行的寬度，其中第limit行的寬度要預留收合按鈕

    for (let i = 0; i < len - 1; i++) {
      const children = target?.children[i];
      const width = children?.getBoundingClientRect().width || 0;

      if (availableSize[currentRow] < width) currentRow += 1;

      if (currentRow > limit) break;

      if (availableSize[currentRow] > width) {
        availableSize[currentRow] = availableSize[currentRow] - (width + gap);
        loc += 1;
      }
    }
  }

  return currentRow < limit ? -1 : loc - 1;
};
